/* eslint-disable no-useless-rename */
import { Dispatch, useEffect, SetStateAction } from 'react';
import { InputLabel } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { FlexCenter } from '../../../styles/stylesStyled';
import {
  ImagePHContainer,
  ImagePHContainerFilled,
  KycBrowseFilesButton,
  Medium,
  Small
} from '../KycStyled';

import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useWindowWide } from '../../../helpers/wideScreen';
import { Dropzone } from './Dropzone';
import { ImgState } from './KycDocumentPhotos';

interface RenderDriversLicenseType {
  id: number;
  percentage: number;
  driversLicense: string;
  imgStateDriversLicense: number;
  setImgStateDriversLicense: Dispatch<SetStateAction<number>>;
  uploadLicenseHandler: any;
  setImage4: Dispatch<SetStateAction<string>>;
  setModal4: Dispatch<SetStateAction<boolean>>;
  setDocumentDriversLicense: Dispatch<SetStateAction<File | string>>;
  setDriversLicense: Dispatch<SetStateAction<string>>;
}

export const RenderDriversLicense = ({
  id,
  driversLicense,
  imgStateDriversLicense,
  setImgStateDriversLicense,
  uploadLicenseHandler,
  setImage4,
  setModal4,
  percentage,
  setDocumentDriversLicense,
  setDriversLicense
}: RenderDriversLicenseType) => {
  const { t } = useTranslation('kyc');
  const wide = useWindowWide(1000);

  const {
    acceptedFiles: acceptedFiles,
    getRootProps: getRootProps,
    isDragAccept: isDragAccept,
    isDragReject: isDragReject
  } = useDropzone({
    accept: { 'image/*': [] },
    multiple: false,
    useFsAccessApi: false
  });

  useEffect(() => {
    const file = acceptedFiles[0];

    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setDriversLicense(objectUrl);
      setDocumentDriversLicense(file);
      setImgStateDriversLicense(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles]);

  return (
    <>
      {id === 2 && (
        <div>
          <InputLabel>{t('document_photos.driver_license')}</InputLabel>
          {driversLicense ? (
            <ImagePHContainerFilled style={{ width: wide ? 375 : '' }}>
              <img
                src={driversLicense}
                alt='upload'
                style={{
                  height: '182px',
                  objectFit: 'cover',
                  filter:
                    imgStateDriversLicense === 2 ? 'blur(8px)' : 'blur(0px)',
                  transition: '.3s filter ease'
                }}
              />
              <ImgState
                state={imgStateDriversLicense}
                setImgState={setImgStateDriversLicense}
                percentage={percentage}
                uploadHandler={(e: any) => uploadLicenseHandler(e)}
                retake={() => {
                  setImage4('');
                  setModal4(true);
                }}
              />
            </ImagePHContainerFilled>
          ) : (
            <Dropzone
              // acceptedFiles={acceptedFiles}
              getRootProps={getRootProps}
              isDragAccept={isDragAccept}
              isDragReject={isDragReject}>
              <ImagePHContainer style={{ width: wide ? 375 : '' }}>
                <div
                  style={{
                    textAlign: 'center'
                  }}>
                  <Medium>{t('document_photos.photo_card_title')}</Medium>
                  <Small>{t('document_photos.photo_card_subtitle')}</Small>

                  <FlexCenter style={{ justifyContent: 'center' }}>
                    <Button
                      fs='12px'
                      h='34px'
                      maxWidth='111px'
                      mr='12'
                      type='button'
                      onClick={() => setModal4(true)}>
                      {t('document_photos.take_photo_button')}
                    </Button>
                    <KycBrowseFilesButton>
                      <input
                        type='file'
                        accept='image/*'
                        style={{ display: 'none' }}
                        onChange={(e) => uploadLicenseHandler(e)}
                      />
                      {t('document_photos.browse_files_button')}
                    </KycBrowseFilesButton>
                  </FlexCenter>
                </div>
              </ImagePHContainer>
            </Dropzone>
          )}
        </div>
      )}
    </>
  );
};
